
/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 22/03/2025
*/

import React from "react";
import Footer3 from "./mainFooter";
import RedFooter from "./redFooter"
import FooterImage from "../../assets/images/img-footer.png"
// import Styles from "./waveBackground.module.css";
import "./waveBackground.module.css";
const WaveBackground = () => {
    return (
        <div className="waveOuter">
            <div className="waveWrapper">
                <div className="waveContainer">

                    <svg width="100%" height="200px" fill="none" version="1.1" xmlns="http://www.w3.org/2000/svg" className="waveContentSVG">
                        <path fill="#0062a3" d="
               M0 67
               C 273,183
                 822,-40
                 1920.00,106 
               V 359 H 0 V 67 Z">
                            <animate repeatCount="indefinite" attributeName="d" dur="18s" attributeType="XML" values="
                 M0 77 
                 C 473,283
                   822,-40
                   1920,116 
                 V 359 H 0 V 67 Z; 
     
                 M0 77 
                 C 473,-40
                   1222,283
                   1920,136 
                 V 359 H 0 V 67 Z; 
     
                 M0 77 
                 C 973,260
                   1722,-53
                   1920,120 
                 V 359 H 0 V 67 Z; 
     
                 M0 77 
                 C 473,283
                   822,-40
                   1920,116 
                 V 250 H 0 V 67 Z
                 " />
                        </path>
                    </svg>
                </div>
            </div>
        </div>

    );
};

export default WaveBackground;
